module.exports = __webpack_public_path__ + "static/media/mdi_vertical_align_top.15cec24e.svg";